import * as React from "react"

const SvgDownload = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 16.146q-.2 0-.375-.062a.9.9 0 0 1-.325-.213l-3.6-3.6a.92.92 0 0 1-.288-.7q.014-.4.288-.7.3-.3.712-.312a.93.93 0 0 1 .713.287L11 12.721v-7.15a.97.97 0 0 1 .287-.712A.97.97 0 0 1 12 4.57a.97.97 0 0 1 .713.288q.287.289.287.712v7.15l1.875-1.875a.93.93 0 0 1 .713-.287q.412.012.712.312.276.3.287.7a.92.92 0 0 1-.287.7l-3.6 3.6a.9.9 0 0 1-.325.213 1.1 1.1 0 0 1-.375.062Zm-6 4.425q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 18.57v-2a.97.97 0 0 1 .287-.712A.97.97 0 0 1 5 15.57a.97.97 0 0 1 .713.288q.287.289.287.712v2h12v-2q0-.424.288-.712A.97.97 0 0 1 19 15.57q.424 0 .712.288.288.289.288.712v2a1.93 1.93 0 0 1-.587 1.413A1.93 1.93 0 0 1 18 20.57H6Z" />
  </svg>
)
export default SvgDownload
